import React from "react";
import { Box, TableContainer, Paper, useTheme, useMediaQuery } from "@mui/material";

export default function ResponsiveTable({
  children,
  cardView = null,
  component = Paper,
  elevation = 0,
  sx = {},
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  if (isMobile && cardView) {
    return <Box sx={{ width: "100%" }}>{cardView}</Box>;
  }

  return (
    <TableContainer
      component={component}
      elevation={elevation}
      sx={{
        width: "100%",
        overflowX: "auto",
        WebkitOverflowScrolling: "touch",
        ...sx,
      }}
    >
      {children}
    </TableContainer>
  );
}
